import type {AppElement} from "@genesislcap/foundation-shell/dist/dts/app";
import {html} from "@genesislcap/web-core";

export const piMenu: AppElement = {
  targetId: 'nav-end',
  elements: html`
    <help-menu></help-menu>
  `,
};
